import { useEffect, useState } from "react";

// Two-pane pages (admin inbox, client Support) switch to list-then-detail at
// this width; it matches the CSS breakpoint where they stop sitting side by side.
export const TWO_PANE_QUERY = "(max-width: 1100px)";

/** True while the media query matches; follows resizes and rotation. */
export function useMedia(query: string): boolean {
  const get = () =>
    typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia(query).matches
      : false;
  const [match, setMatch] = useState(get);
  useEffect(() => {
    const mq = window.matchMedia(query);
    const on = () => setMatch(mq.matches);
    on();
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, [query]);
  return match;
}
